import { render, staticRenderFns } from "./CoordenadasClientes.vue?vue&type=template&id=3624e8a6&lang=pug"
import script from "./CoordenadasClientes.vue?vue&type=script&lang=js"
export * from "./CoordenadasClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports